import { ChangeDetectionStrategy, Component, inject, input, OnDestroy, OnInit, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { SearchFields, SearchPatientCaseResult } from '../../core';
import { ListService } from '../../services';
import { BaseComponent, PaginationComponent, SortEvent } from '../../shared';
import { PatientTableComponent } from '../patient-table';


/**
 * Component for table of List of Patients page.
 */
@Component({
	selector: 'tsp-list-table',
	imports: [
		PaginationComponent,
		PatientTableComponent
	],
	templateUrl: './list-table.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ListTableComponent extends BaseComponent implements OnInit, OnDestroy {

	private readonly listSrv = inject(ListService);

	isFiltersCollapsed = input(false);

	collectionSize = signal<number>(0);
	items = signal<SearchPatientCaseResult[]>([]);
	private readonly _DEFAULT_ORDER: SortEvent = { column: SearchFields.lastCasePublish, direction: 'desc' };
	sortOrder = signal<SortEvent>({ ...this._DEFAULT_ORDER });

	pageNumber: number = 1;
	pageSize: number = 10;

	private _searchSubscription$?: Subscription;


	ngOnInit(): void {
		this._searchSubscription$ = this.listSrv.getSearchResult().subscribe(res => {
			this.collectionSize.set(res.count);
			this.items.set(res.items);
		});
	}

	/**
	 * Update list by sort order.
	 */
	updateSortOrder(order?: SortEvent): void {
		if (!order || (order.direction === '' && order.column !== this._DEFAULT_ORDER.column)) order = { ...this._DEFAULT_ORDER };
		this.sortOrder.set(order);
		this.listSrv.changeSortOrder(order);
	}

	/**
	 * Update list by page number.
	 */
	updatePageNumber(): void {
		this.listSrv.changePageNumber(this.pageNumber);
	}

	/**
	 * Update list by page size.
	 */
	updatePageSize(): void {
		this.listSrv.changePageSize(this.pageSize);
		this.pageNumber = 1;
	}


	ngOnDestroy(): void {
		this._searchSubscription$?.unsubscribe();
	}

}
